import Vue from 'vue'
const state = Vue.observable({
  message: null,
  showConfirmModal: false,
  accepted: null
})

export const getters = {
  message: () => state.message,
  showConfirmModal () { return state.showConfirmModal },
  accepted: () => state.accepted
}

export const mutations = {
  SHOW_CONFIRM_MODAL: (message) => {
    state.showConfirmModal = true
    state.message = message
  },

  ACCEPT: () => {
    state.accepted = 1
  },

  DECLINE: () => {
    state.accepted = 0
  },

  CLEAR: () => {
    state.showConfirmModal = false
    state.accepted = null
    state.message = null
  }
}
